import React, { useState, useEffect, useCallback } from 'react';
import './AdminUsuarios.css';

const API_AUTH  = 'https://centrocomunicar.com/api-comunicar/endpoints/auth.php';
const API_LEADS = 'https://centrocomunicar.com/api-comunicar/endpoints/leads.php';

/* ── Icons ── */
const IconSearch   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconRefresh  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUsers    = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M16 3.13a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconEdit     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconEye      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconToggle   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><rect x="1" y="5" width="22" height="14" rx="7" stroke="currentColor" strokeWidth="2"/><circle cx="16" cy="12" r="4" fill="currentColor"/></svg>);
const IconMail     = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/><polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconDownload = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="7 10 12 15 17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconShield   = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconExport   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="17 8 12 3 7 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconWhatsapp = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconFilter   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconLink     = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

const PERFIL_COLORS = { terapeuta:'verde', profesor:'azul', familia:'amarillo', afin:'morado' };

const NIVEL_COLORS  = { explorador:'gris', comunicador:'verde', especialista:'dorado', experto:'negro' };

function fmtFecha(str) {
  if (!str) return '—';
  return new Date(str).toLocaleDateString('es-PE', { day:'2-digit', month:'short', year:'numeric' });
}

/* ════════════════════════════════════════
   COMPONENTE PRINCIPAL
════════════════════════════════════════ */
export default function AdminUsuarios() {
  const [usuarios,   setUsuarios]   = useState([]);
  const [loading,    setLoading]    = useState(false);
  const [busqueda,   setBusqueda]   = useState('');
  const [filtroEstado,  setFiltroEstado]  = useState('todos');
  const [filtroPerfil,  setFiltroPerfil]  = useState('todos');
  const [filtroOrigen,  setFiltroOrigen]  = useState('todos'); // todos | registro | suscriptor
  const [toast,      setToast]      = useState(null);
  const [modalUsuario, setModalUsuario] = useState(null); // usuario seleccionado
  const [modalMode,  setModalMode]  = useState('ver'); // ver | editar
  const [formEdit,   setFormEdit]   = useState({});
  const [guardando,  setGuardando]  = useState(false);

  const [modalNuevo,   setModalNuevo]   = useState(false);
  const [formNuevo,    setFormNuevo]    = useState({ nombre:'', apellido:'', email:'', telefono:'', whatsapp:'', perfil:'profesional', password:'' });
  const [creando,      setCreando]      = useState(false);
  const [passGenerada, setPassGenerada] = useState('');

  const showToast = (msg, tipo='ok') => { setToast({msg,tipo}); setTimeout(()=>setToast(null),3000); };

  /* ── Fetch usuarios ── */
  const fetchUsuarios = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API_AUTH}?action=admin_usuarios`);
      const j = await r.json();
      if (j.success) setUsuarios(j.data || []);
      else showToast(j.message || 'Error cargando usuarios', 'error');
    } catch(e) { showToast('Error de conexión', 'error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchUsuarios(); }, [fetchUsuarios]);

  /* ── Filtrar ── */
  const q = busqueda.toLowerCase();
  const filtrados = usuarios.filter(u => {
    const matchBus    = !q || u.nombre?.toLowerCase().includes(q) || u.email?.toLowerCase().includes(q) || u.apellido?.toLowerCase().includes(q);
    const matchEstado = filtroEstado === 'todos'
      || (filtroEstado === 'activo'    && u.activo == 1)
      || (filtroEstado === 'inactivo'  && u.activo == 0)
      || (filtroEstado === 'verificado'&& u.email_verificado == 1)
      || (filtroEstado === 'sin_verificar' && u.email_verificado == 0);
    const matchPerfil = filtroPerfil === 'todos' || u.perfil === filtroPerfil;
    const matchOrigen = filtroOrigen === 'todos'
      || (filtroOrigen === 'registro'   && !u.lead_id)
      || (filtroOrigen === 'suscriptor' && !!u.lead_id);
    return matchBus && matchEstado && matchPerfil && matchOrigen;
  });

  /* ── KPIs ── */
  const totalActivos    = usuarios.filter(u => u.activo == 1).length;
  const totalVerificados= usuarios.filter(u => u.email_verificado == 1).length;
  const conLead         = usuarios.filter(u => !!u.lead_id).length;
  const totalDescargas  = usuarios.reduce((a,u) => a + (parseInt(u.total_descargas||0)), 0);

  /* ── Abrir modal ── */
  const abrirModal = (u, modo='ver') => {
    setModalUsuario(u);
    setModalMode(modo);
    setFormEdit({
      nombre:   u.nombre   || '',
      apellido: u.apellido || '',
      telefono: u.telefono || '',
      whatsapp: u.whatsapp || '',
      perfil:   u.perfil   || 'otro',
    });
  };

  /* ── Guardar edición ── */
  const guardarEdicion = async () => {
    if (!formEdit.nombre?.trim()) { showToast('El nombre es obligatorio', 'error'); return; }
    setGuardando(true);
    try {
      const r = await fetch(`${API_AUTH}?action=admin_editar_usuario`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: modalUsuario.id, ...formEdit }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast('Usuario actualizado');
      setModalUsuario(null);
      fetchUsuarios();
    } catch(err) { showToast(err.message, 'error'); }
    finally { setGuardando(false); }
  };

  /* ── Toggle activo/inactivo ── */
  const toggleActivo = async (u) => {
    try {
      const r = await fetch(`${API_AUTH}?action=admin_toggle_activo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: u.id, activo: u.activo == 1 ? 0 : 1 }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(u.activo == 1 ? 'Usuario desactivado' : 'Usuario activado');
      setModalUsuario(null);
      fetchUsuarios();
    } catch(err) { showToast(err.message, 'error'); }
  };

  /* ── Exportar CSV ── */
  const exportarCSV = () => {
    const headers = ['Nombre','Apellido','Email','Teléfono','Perfil','Activo','Verificado','Origen','Descargas','Puntos','Nivel','Registrado'];
    const rows = filtrados.map(u => [
      u.nombre, u.apellido||'', u.email, u.telefono||'',
      u.perfil, u.activo?'Sí':'No', u.email_verificado?'Sí':'No',
      u.lead_id ? 'Suscriptor previo' : 'Registro directo',
      u.total_descargas||0, u.puntos_disponibles||0, u.nivel||'explorador',
      fmtFecha(u.created_at)
    ]);
    const csv = [headers, ...rows].map(r => r.map(v=>`"${v}"`).join(',')).join('\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob(['\ufeff'+csv],{type:'text/csv;charset=utf-8;'}));
    a.download = `usuarios_${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    showToast('CSV exportado');
  };



  const generarPassword = () => {
    var chars = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789@#$';
    var pass  = '';
    for (var i = 0; i < 10; i++) {
      pass += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return pass;
  };
 
  const abrirModalNuevo = () => {
    var pass = generarPassword();
    setPassGenerada(pass);
    setFormNuevo({ nombre:'', apellido:'', email:'', telefono:'', whatsapp:'', perfil:'profesional', password: pass });
    setModalNuevo(true);
  };
 
  const crearUsuario = async () => {
    if (!formNuevo.nombre.trim())        { showToast('El nombre es obligatorio', 'error'); return; }
    if (!formNuevo.email.includes('@'))  { showToast('Email no valido', 'error'); return; }
    if (!formNuevo.password.trim())      { showToast('La contrasena es obligatoria', 'error'); return; }
    setCreando(true);
    try {
      var r = await fetch(API_AUTH + '?action=admin_crear_usuario', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formNuevo),
      });
      var j = await r.json();
      if (!j.success) throw new Error(j.message || 'Error al crear usuario');
      showToast('Usuario creado y correo enviado');
      setModalNuevo(false);
      fetchUsuarios();
    } catch(err) { showToast(err.message, 'error'); }
    finally { setCreando(false); }
  };




  const iniciales = u => ((u.nombre||'')[0] + (u.apellido||u.nombre||'')[u.apellido?0:1] || 'U').toUpperCase();

  return (
    <div className="au-page">

      {toast && (
        <div className={`au-toast au-toast--${toast.tipo}`}>
          {toast.tipo==='ok'?<IconCheck/>:<IconClose/>} {toast.msg}
        </div>
      )}

      {/* HEADER */}
      <div className="au-header">
        <div>
          <h1>Usuarios registrados</h1>
          <p>Usuarios con cuenta activa en el sitio web</p>
        </div>
        <div className="au-header__actions">
          <button className="au-btn-ghost" onClick={fetchUsuarios}><IconRefresh/> Actualizar</button>
          <button className="au-btn-primary" onClick={abrirModalNuevo}>
    + Nuevo usuario
  </button>
          <button className="au-btn-ghost" onClick={exportarCSV}><IconExport/> Exportar CSV</button>
        </div>
      </div>

      {/* KPIs */}
      <div className="au-kpis">
        <div className="au-kpi au-kpi--verde">
          <div className="au-kpi__icon"><IconUsers/></div>
          <p>Usuarios activos</p>
          <strong>{loading?'…':totalActivos}</strong>
          <span>de {usuarios.length} registrados</span>
        </div>
        <div className="au-kpi">
          <div className="au-kpi__icon au-kpi__icon--azul"><IconMail/></div>
          <p>Emails verificados</p>
          <strong>{loading?'…':totalVerificados}</strong>
          <span>confirmaron su correo</span>
        </div>
        <div className="au-kpi">
          <div className="au-kpi__icon au-kpi__icon--amarillo"><IconLink/></div>
          <p>Suscriptores previos</p>
          <strong>{loading?'…':conLead}</strong>
          <span>ya eran leads antes</span>
        </div>
        <div className="au-kpi">
          <div className="au-kpi__icon au-kpi__icon--rosa"><IconDownload/></div>
          <p>Descargas totales</p>
          <strong>{loading?'…':totalDescargas}</strong>
          <span>recursos descargados</span>
        </div>
      </div>

      {/* TOOLBAR */}
      <div className="au-toolbar">
        <div className="au-search">
          <IconSearch/>
          <input type="text" placeholder="Buscar por nombre o email…"
            value={busqueda} onChange={e=>setBusqueda(e.target.value)}/>
          {busqueda && <button className="au-search__clear" onClick={()=>setBusqueda('')}><IconClose/></button>}
        </div>

        <div className="au-filtros">
          <IconFilter/>
          {[
            {id:'todos',       label:'Todos'},
            {id:'activo',      label:'Activos'},
            {id:'inactivo',    label:'Inactivos'},
            {id:'verificado',  label:'Verificados'},
            {id:'sin_verificar',label:'Sin verificar'},
          ].map(f=>(
            <button key={f.id}
              className={`au-filtro ${filtroEstado===f.id?'au-filtro--active':''}`}
              onClick={()=>setFiltroEstado(f.id)}
            >{f.label}</button>
          ))}
        </div>

        <div className="au-toolbar__right">
          <select className="au-select" value={filtroPerfil} onChange={e=>setFiltroPerfil(e.target.value)}>
            <option value="todos">Todos los perfiles</option>
            <option value="terapeuta">Terapeuta</option>
<option value="profesor">Profesor(a)</option>
<option value="familia">Familia</option>
<option value="afin">Profesionales afines</option>
          </select>

          <select className="au-select" value={filtroOrigen} onChange={e=>setFiltroOrigen(e.target.value)}>
            <option value="todos">Todos los orígenes</option>
            <option value="registro">Registro directo</option>
            <option value="suscriptor">Era suscriptor antes</option>
          </select>

          <span className="au-count">{filtrados.length} usuarios</span>
        </div>
      </div>

      {/* TABLA */}
      <div className="au-tabla-wrap au-card">
        <table className="au-tabla">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Perfil</th>
              <th>Origen</th>
              <th>Descargas</th>
              <th>Puntos / Nivel</th>
              <th>Estado</th>
              <th>Verificado</th>
              <th>Registrado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="9" className="au-loading-row">
                <div className="au-spinner"/> Cargando usuarios…
              </td></tr>
            ) : filtrados.length === 0 ? (
              <tr><td colSpan="9" className="au-empty-row">
                {usuarios.length === 0 ? 'Aún no hay usuarios registrados' : 'Sin resultados'}
              </td></tr>
            ) : filtrados.map(u => (
              <tr key={u.id} className="au-tr">
                {/* Usuario */}
                <td>
                  <div className="au-user-info">
                    <div className="au-avatar">{iniciales(u)}</div>
                    <div>
                      <strong>{u.nombre} {u.apellido}</strong>
                      <span>{u.email}</span>
                      {u.whatsapp && (
                        <a href={`https://wa.me/${u.whatsapp?.replace(/\D/g,'')}`}
                          target="_blank" rel="noopener noreferrer"
                          className="au-wa-link">
                          <IconWhatsapp/> {u.whatsapp}
                        </a>
                      )}
                    </div>
                  </div>
                </td>

                {/* Perfil */}
                <td>
                  <span className={`au-badge au-badge--${PERFIL_COLORS[u.perfil]||'gris'}`}>
                    {u.perfil||'otro'}
                  </span>
                </td>

                {/* Origen */}
                <td>
                  {u.lead_id
                    ? <span className="au-origen au-origen--lead"><IconLink/> Suscriptor previo</span>
                    : <span className="au-origen au-origen--nuevo"><IconUsers/> Registro directo</span>
                  }
                </td>

                {/* Descargas */}
                <td>
                  <span className={`au-desc-badge ${parseInt(u.total_descargas||0)>0?'au-desc-badge--ok':''}`}>
                    {u.total_descargas||0}
                  </span>
                </td>

                {/* Puntos / Nivel */}
                <td>
                  <div className="au-puntos-info">
                    <strong>{u.puntos_disponibles||0} pts</strong>
                    <span className={`au-nivel au-nivel--${NIVEL_COLORS[u.nivel]||'gris'}`}>
                      <IconShield/> {u.nivel||'explorador'}
                    </span>
                  </div>
                </td>

                {/* Estado */}
                <td>
                  <span className={`au-estado ${u.activo?'au-estado--activo':'au-estado--inactivo'}`}>
                    {u.activo?'● Activo':'○ Inactivo'}
                  </span>
                </td>

                {/* Verificado */}
                <td>
                  {u.email_verificado
                    ? <span className="au-verificado"><IconCheck/> Sí</span>
                    : <span className="au-pendiente">Pendiente</span>
                  }
                </td>

                {/* Fecha */}
                <td className="au-fecha">{fmtFecha(u.created_at)}</td>

                {/* Acciones */}
                <td>
                  <div className="au-acciones">
                    <button className="au-icon-btn au-icon-btn--ver"   onClick={()=>abrirModal(u,'ver')}   title="Ver detalle"><IconEye/></button>
                    <button className="au-icon-btn au-icon-btn--edit"  onClick={()=>abrirModal(u,'editar')} title="Editar"><IconEdit/></button>
                    <button className={`au-icon-btn ${u.activo?'au-icon-btn--off':'au-icon-btn--on'}`}
                      onClick={()=>toggleActivo(u)}
                      title={u.activo?'Desactivar':'Activar'}
                    ><IconToggle/></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ══ MODAL ══ */}
      {modalUsuario && (
        <div className="au-overlay" onClick={()=>setModalUsuario(null)}>
          <div className="au-modal" onClick={e=>e.stopPropagation()}>

            <div className="au-modal__head">
              <div className="au-modal__user">
                <div className="au-avatar au-avatar--lg">{iniciales(modalUsuario)}</div>
                <div>
                  <h2>{modalUsuario.nombre} {modalUsuario.apellido}</h2>
                  <p>{modalUsuario.email}</p>
                  <div className="au-modal__badges">
                    <span className={`au-badge au-badge--${PERFIL_COLORS[modalUsuario.perfil]||'gris'}`}>{modalUsuario.perfil}</span>
                    <span className={`au-estado ${modalUsuario.activo?'au-estado--activo':'au-estado--inactivo'}`}>
                      {modalUsuario.activo?'Activo':'Inactivo'}
                    </span>
                    {modalUsuario.email_verificado
                      ? <span className="au-verificado"><IconCheck/> Verificado</span>
                      : <span className="au-pendiente">Sin verificar</span>
                    }
                  </div>
                </div>
              </div>
              <div className="au-modal__head-actions">
                <button
                  className={`au-btn-ghost au-btn-toggle ${modalUsuario.activo?'au-btn-toggle--off':'au-btn-toggle--on'}`}
                  onClick={()=>toggleActivo(modalUsuario)}
                >
                  <IconToggle/> {modalUsuario.activo?'Desactivar':'Activar'}
                </button>
                <button className="au-modal__close" onClick={()=>setModalUsuario(null)}><IconClose/></button>
              </div>
            </div>

            <div className="au-modal__tabs">
              <button className={`au-modal__tab ${modalMode==='ver'?'au-modal__tab--active':''}`} onClick={()=>setModalMode('ver')}>
                <IconEye/> Detalle
              </button>
              <button className={`au-modal__tab ${modalMode==='editar'?'au-modal__tab--active':''}`} onClick={()=>setModalMode('editar')}>
                <IconEdit/> Editar
              </button>
            </div>

            <div className="au-modal__body">

              {/* ── VER ── */}
              {modalMode === 'ver' && (
                <div className="au-modal__detalle">
                  <div className="au-detail-stats">
                    <div className="au-detail-stat">
                      <strong>{modalUsuario.total_descargas||0}</strong>
                      <span>Descargas</span>
                    </div>
                    <div className="au-detail-stat">
                      <strong>{modalUsuario.puntos_disponibles||0}</strong>
                      <span>Puntos</span>
                    </div>
                    <div className="au-detail-stat">
                      <strong>{modalUsuario.nivel||'explorador'}</strong>
                      <span>Nivel</span>
                    </div>
                    <div className="au-detail-stat">
                      <strong>{fmtFecha(modalUsuario.ultimo_login)}</strong>
                      <span>Último login</span>
                    </div>
                  </div>

                  <div className="au-detail-grid">
                    {[
                      ['Email',     modalUsuario.email],
                      ['Teléfono',  modalUsuario.telefono || '—'],
                      ['WhatsApp',  modalUsuario.whatsapp || '—'],
                      ['País',      modalUsuario.pais || '—'],
                      ['Origen',    modalUsuario.lead_id ? 'Era suscriptor/lead' : 'Registro directo'],
                      ['Registrado',fmtFecha(modalUsuario.created_at)],
                    ].map(([label, val]) => (
                      <div className="au-detail-item" key={label}>
                        <span>{label}</span>
                        <strong>{val}</strong>
                      </div>
                    ))}
                  </div>

                  {/* WhatsApp directo */}
                  {modalUsuario.whatsapp && (
                    <a
                      href={`https://wa.me/${modalUsuario.whatsapp.replace(/\D/g,'')}?text=Hola%20${encodeURIComponent(modalUsuario.nombre)}%2C%20te%20contactamos%20desde%20Comunicar.`}
                      target="_blank" rel="noopener noreferrer"
                      className="au-wa-contact"
                    >
                      <IconWhatsapp/> Contactar por WhatsApp
                    </a>
                  )}
                </div>
              )}

              {/* ── EDITAR ── */}
              {modalMode === 'editar' && (
                <div className="au-modal__edit">
                  <div className="au-edit-grid">
                    {[
                      {label:'Nombre *',   key:'nombre',   type:'text', placeholder:'Nombre'},
                      {label:'Apellido',   key:'apellido', type:'text', placeholder:'Apellido'},
                      {label:'Teléfono',   key:'telefono', type:'tel',  placeholder:'+51 999 000 111'},
                      {label:'WhatsApp',   key:'whatsapp', type:'tel',  placeholder:'+51 999 000 111'},
                    ].map(({label,key,type,placeholder})=>(
                      <div className="au-edit-field" key={key}>
                        <label>{label}</label>
                        <input type={type} placeholder={placeholder}
                          value={formEdit[key]||''}
                          onChange={e=>setFormEdit(f=>({...f,[key]:e.target.value}))}
                        />
                      </div>
                    ))}

                    <div className="au-edit-field au-edit-field--full">
                      <label>Perfil</label>
                      <div className="au-perfil-tabs">
                        {[{val:'profesional',label:'Profesional'},{val:'familia',label:'Familia'},{val:'estudiante',label:'Estudiante'},{val:'otro',label:'Otro'}].map(({val,label})=>(
                          <button key={val} type="button"
                            className={`au-perfil-tab ${formEdit.perfil===val?'au-perfil-tab--active':''}`}
                            onClick={()=>setFormEdit(f=>({...f,perfil:val}))}
                          >{label}</button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}

            </div>

            <div className="au-modal__foot">
              <button className="au-btn-ghost" onClick={()=>setModalUsuario(null)}>Cerrar</button>
              {modalMode === 'editar' && (
                <button className="au-btn-primary" onClick={guardarEdicion} disabled={guardando}>
                  {guardando ? <><span className="au-spinner"/>Guardando…</> : <><IconCheck/> Guardar cambios</>}
                </button>
              )}
            </div>
          </div>
        </div>
      )}







  {/* MODAL NUEVO USUARIO */}
  {modalNuevo && (
        <div className="au-overlay" onClick={function() { setModalNuevo(false); }}>
          <div className="au-modal" onClick={function(e) { e.stopPropagation(); }} style={{maxWidth: 520}}>
 
            <div className="au-modal__head">
              <div>
                <h2>Crear usuario manualmente</h2>
                <p style={{fontSize:'.82rem',color:'#5a6a63',marginTop:'.2rem'}}>
                  Se enviara un correo al usuario con sus credenciales de acceso.
                </p>
              </div>
              <button className="au-modal__close" onClick={function() { setModalNuevo(false); }}>
                <IconClose/>
              </button>
            </div>
 
            <div className="au-modal__body">
              <div className="au-edit-grid">
 
                <div className="au-edit-field">
                  <label>Nombre <span style={{color:'#dc2626'}}>*</span></label>
                  <input
                    type="text" placeholder="Nombre"
                    value={formNuevo.nombre}
                    onChange={function(e) { setFormNuevo(function(p) { return Object.assign({},p,{nombre:e.target.value}); }); }}
                  />
                </div>
 
                <div className="au-edit-field">
                  <label>Apellido</label>
                  <input
                    type="text" placeholder="Apellido"
                    value={formNuevo.apellido}
                    onChange={function(e) { setFormNuevo(function(p) { return Object.assign({},p,{apellido:e.target.value}); }); }}
                  />
                </div>
 
                <div className="au-edit-field au-edit-field--full">
                  <label>Correo electronico <span style={{color:'#dc2626'}}>*</span></label>
                  <input
                    type="email" placeholder="usuario@correo.com"
                    value={formNuevo.email}
                    onChange={function(e) { setFormNuevo(function(p) { return Object.assign({},p,{email:e.target.value}); }); }}
                  />
                </div>
 
                <div className="au-edit-field">
                  <label>Telefono</label>
                  <input
                    type="tel" placeholder="+51 999 000 111"
                    value={formNuevo.telefono}
                    onChange={function(e) { setFormNuevo(function(p) { return Object.assign({},p,{telefono:e.target.value}); }); }}
                  />
                </div>
 
                <div className="au-edit-field">
                  <label>WhatsApp</label>
                  <input
                    type="tel" placeholder="+51 999 000 111"
                    value={formNuevo.whatsapp}
                    onChange={function(e) { setFormNuevo(function(p) { return Object.assign({},p,{whatsapp:e.target.value}); }); }}
                  />
                </div>
 
                <div className="au-edit-field au-edit-field--full">
                  <label>Perfil</label>
                  <div className="au-perfil-tabs">
                    {[
                       {val:'terapeuta',   label:'Terapeuta'},
                       {val:'profesor',    label:'Profesor(a)'},
                       {val:'familia',     label:'Familia'},
                       {val:'afin',        label:'Profesionales afines'},
                    ].map(function(op) {
                      return (
                        <button
                          key={op.val} type="button"
                          className={'au-perfil-tab ' + (formNuevo.perfil === op.val ? 'au-perfil-tab--active' : '')}
                          onClick={function() { setFormNuevo(function(p) { return Object.assign({},p,{perfil:op.val}); }); }}
                        >
                          {op.label}
                        </button>
                      );
                    })}
                  </div>
                </div>
 
                <div className="au-edit-field au-edit-field--full">
                  <label>Contrasena temporal <span style={{color:'#dc2626'}}>*</span></label>
                  <div style={{display:'flex', gap:'.5rem'}}>
                    <input
                      type="text"
                      value={formNuevo.password}
                      onChange={function(e) { setFormNuevo(function(p) { return Object.assign({},p,{password:e.target.value}); }); }}
                      style={{flex:1, fontFamily:'monospace', letterSpacing:'.05em'}}
                    />
                    <button
                      type="button"
                      onClick={function() {
                        var pass = generarPassword();
                        setPassGenerada(pass);
                        setFormNuevo(function(p) { return Object.assign({},p,{password:pass}); });
                      }}
                      style={{
                        padding:'.5rem .9rem', borderRadius:8, border:'1.5px solid rgba(130,216,179,.3)',
                        background:'var(--gris-lt,#f3f8f5)', fontFamily:'inherit', fontSize:'.8rem',
                        fontWeight:600, cursor:'pointer', whiteSpace:'nowrap',
                      }}
                    >
                      Generar nueva
                    </button>
                  </div>
                  <span style={{fontSize:'.72rem',color:'#5a6a63',marginTop:'.25rem',display:'block'}}>
                    Esta contrasena se enviara al correo del usuario. El usuario puede cambiarla despues.
                  </span>
                </div>
 
                {/* Preview credenciales */}
                <div className="au-edit-field au-edit-field--full">
                  <div style={{
                    background:'#f0fdf4', border:'1.5px solid #bbf7d0',
                    borderRadius:12, padding:'1rem 1.2rem',
                  }}>
                    <p style={{fontSize:'.75rem',fontWeight:700,color:'#065f46',marginBottom:'.6rem',textTransform:'uppercase',letterSpacing:'.08em'}}>
                      Credenciales que se enviaran
                    </p>
                    <div style={{display:'flex',flexDirection:'column',gap:'.3rem'}}>
                      <div style={{display:'flex',justifyContent:'space-between',fontSize:'.85rem'}}>
                        <span style={{color:'#5a6a63'}}>Usuario (email)</span>
                        <strong style={{color:'#111',fontFamily:'monospace'}}>{formNuevo.email || '—'}</strong>
                      </div>
                      <div style={{display:'flex',justifyContent:'space-between',fontSize:'.85rem'}}>
                        <span style={{color:'#5a6a63'}}>Contrasena</span>
                        <strong style={{color:'#111',fontFamily:'monospace'}}>{formNuevo.password || '—'}</strong>
                      </div>
                      <div style={{display:'flex',justifyContent:'space-between',fontSize:'.85rem'}}>
                        <span style={{color:'#5a6a63'}}>Rol</span>
                        <strong style={{color:'#111'}}>Usuario ({formNuevo.perfil})</strong>
                      </div>
                    </div>
                  </div>
                </div>
 
              </div>
            </div>
 
            <div className="au-modal__foot">
              <button className="au-btn-ghost" onClick={function() { setModalNuevo(false); }}>
                Cancelar
              </button>
              <button
                className="au-btn-primary"
                onClick={crearUsuario}
                disabled={creando}
              >
                {creando
                  ? <><span className="au-spinner"/> Creando...</>
                  : <><IconCheck/> Crear y enviar credenciales</>
                }
              </button>
            </div>
 
          </div>
        </div>
      )}







    </div>
  );
}